import { defineMessages } from 'react-intl';

export const agentCreditAllowanceBannerMessages = defineMessages({
  /** In-chat 100% copy — `release-growth-heidi-2-usage-nudges` ON. */
  exhaustedTitle: {
    defaultMessage: "You've reached your usage limit",
    id: 'qT6WC9ZZOG',
    description:
      'In-chat credit banner title when Standard-seat usage remaining is at or below zero (usage-nudges flag on)',
  },
  exhaustedDescription: {
    defaultMessage:
      'You can continue using Evidence. Limit resets on {date}. <learnMore>Learn more</learnMore>',
    id: 'ciwLn+W7qj',
    description:
      'In-chat credit banner body at remaining zero — Evidence continues after Heidi 2 limit; reset date and help-center link (usage-nudges flag on)',
  },
  exhaustedUpgradeCta: {
    defaultMessage: 'Upgrade',
    id: 'V6xDBVwS6I',
    description:
      'In-chat credit banner upgrade button at remaining zero (usage-nudges flag on)',
  },
  /** In-chat 100% copy — usage-nudges flag OFF. */
  legacyExhaustedTitle: {
    defaultMessage: 'You used up your usage.',
    id: 'G2FUrzHhFA',
    description: 'In-chat credit banner title at remaining zero (usage-nudges flag off)',
  },
  legacyExhaustedDescription: {
    defaultMessage: 'Resets {date}, {time}.',
    id: 'LMawNALHP9',
    description:
      'In-chat credit banner description at remaining zero — reset only, no multiplier upsell (usage-nudges flag off)',
  },
  workflowAlmostTitle: {
    defaultMessage: "You've almost reached usage limit",
    id: 'gQDNnfrGYM',
    description: 'Routines page credit banner title at 90% usage',
  },
  workflowAlmostDescription: {
    defaultMessage: 'Your routines will pause. Your routine will restart on {date}.',
    id: 'UsRAw3dweF',
    description: 'Routines page credit banner body at 90% usage; date is cycle reset',
  },
  workflowReachedTitle: {
    defaultMessage: "You've reached usage limit",
    id: 'jSqM3j+pzR',
    description: 'Routines page credit banner title at 100% usage',
  },
  workflowReachedDescription: {
    defaultMessage: 'Your routines have paused. Your routine will restart on {date}.',
    id: 'SZaUutiu9D',
    description: 'Routines page credit banner body at 100% usage; date is cycle reset',
  },
  workflowUpgradeCta: {
    defaultMessage: 'Upgrade',
    id: 'g8V7CkUAxt',
    description: 'Routines page credit banner upgrade button label',
  },
});
